<template>
<div>
  <div class="banner">
    <div class="bannerImg">
      <img :src="bannerImg" alt /> 
    </div>

    <div class="banner_text">
      <div class="wenzi">
        <img :src="wenziImg" />
      </div>
    </div> 
  </div>
    
</div>
</template>

<script>
export default {
  name: "banner",
  data() {
    return {
      bannerImg: require("../../assets/img/pc/banner/banner.png"), 
      wenziImg: require("../../assets/img/pc/banner/title.png"),
      wenziImg2: require("../../assets/img/pc/banner/title2.png")
    };
  },
  created() {
    // if (window.location.host == "sxdc.chineseall.cn") {
    //   this.wenziImg = require("../../assets/img/pc/zhutid.png");
    // } else {
    //   this.wenziImg = require("../../assets/img/pc/zhuti.png");
    // }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>

.banner {
  width: 100%;
  height: 12.17rem;
  position: relative;
 
  .bannerImg {
    width: 100%;
    height: 100%;
    display: block;
    position: absolute;
    top: 0;
    left: 0;
    img {
      width: 100%;
    }
  }
  .banner_text {
    width: 11.26rem;
    height: auto;
    position: absolute;
    top: 1.22rem;
    left: 50%;
    transform: translateX(-50%);
    .wenzi {
      width: 100%;
      margin: 0 auto;
      img {
        width: 100%;
        height: auto;
      }
    }
    
  }
  .banner_text2{
    width: 4.82rem;
    height: 1.08rem;
    position: absolute;
    top: 5rem;;
    right: 5.29rem; 
    .wenzi {
      width: 100%;
      margin: 0 auto;
      img {
        width: 100%;
        height: auto;
      }
    }
  }
}
.words{
  width: 100%;
  height: auto;
  padding: 0.32rem 1.32rem 0.456rem;
  font-size: 0.32rem;
  color: #2B2B2B;
  background-color: #fff;
  .author{
    text-align: right;
  }
}
</style>
